import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

import store from './store';
import AppRoot from './containers/AppRoot';
import ScrollToTop from './components/ScrollToTop';

import './index.css';
import './assets/theme/structure.css';
import './assets/theme/animate.css';
import './assets/theme/responsive.css';

// import './assets/theme/style.css';

ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			<ScrollToTop>
				<AppRoot />
			</ScrollToTop>
		</BrowserRouter>
	</Provider>,
	document.getElementById('root')
);

//registerServiceWorker();
unregister();


// WEBPACK FOOTER //
// ./src/index.js